export const sort = xs => Array.prototype.sort.call(xs);
